export const CHANNEL_GROUP = 'channelGroup'
export const PROFIT_LENS = 'profitLens'

export const SHOW_ALL = 'Show All'
